import axios from "../httpClient";
import { getDs82BotStatus } from "./ds82BotStatus";
import { patchDs82BotStatusPause } from "./ds82BotStatusPause";

function getBotMonitoring() {
  return axios.get("/bot-status");
}

export default {
  getBotMonitoring,
  getDs82BotStatus,
  patchDs82BotStatusPause,
};
